import React, { useMemo } from 'react'
import { DataGrid, filteredColumnDefsBuilder, GridAutoSizing, GridId } from 'view/components/datagrid'

import { tradingFatFingerLimitsColumnDefs, fatFingerLimitsGridOptions, TradingFatFingerGridColumnId } from './FatFingerLimitsGridModel'
import { fatFingerLimitUserGetterSelector } from 'selectors/userSelectors'
import { useAuthorisedUser, useUser } from 'view/hooks'
import { useSelector } from 'react-redux'

export const TradingFatFingerLimitsGrid: React.FunctionComponent = () => {
  const authorisedUser = useAuthorisedUser()
  const currentUser = useUser(authorisedUser.id)

  const userFatFingerLimits = useSelector(fatFingerLimitUserGetterSelector)(currentUser?.id || '')

  const filteredColumnDefs = useMemo(() => {
    const columnDefs = tradingFatFingerLimitsColumnDefs()
    return filteredColumnDefsBuilder(columnDefs)
      .withoutIf(true, [TradingFatFingerGridColumnId.FAT_FINGER_ACTIONS])
      .build()
  }, [])

  return (
    <DataGrid
      gridId={GridId.SalesCoverageGrid}
      gridOptions={fatFingerLimitsGridOptions}
      gridColumnAutoSizing={GridAutoSizing.NONE}
      disableGrouping={true}
      columnDefs={filteredColumnDefs}
      rowData={userFatFingerLimits}
      customToolbarComponents={[]}
    />
  )
}
